import { useMemo } from 'react'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

import { getExcludedEmailsKey } from '../lib/getExcludedEmailsKey'

export const usePbmSignerPickerSource = (partnerId: string, excludedEmails: string[] = []) => {
  const excludedEmailsKey = getExcludedEmailsKey(excludedEmails)
  return useMemo(() => {
    const crud = CrudStore.get(
      'JBPHPContactChangeRequest',
      `acknowledgment-pbm-picker:${partnerId}:${excludedEmailsKey}`
    )

    crud.setPaging({
      page: 0,
      pageSize: 5,
    })

    crud.setSort({
      field: 'Modified',
      dir: 'desc',
    })

    crud.setDefaultFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'PartnerId',
          operator: Operator.EQUAL,
          value: partnerId,
        },
        ...(excludedEmailsKey ? excludedEmailsKey.split(';') : []).map((email) => ({
          field: 'Email',
          operator: Operator.NOTEQUAL,
          value: email,
        })),
      ],
    })

    return crud
  }, [partnerId, excludedEmailsKey])
}
